const EA_MERCHANT_ID = '119920';

export const isEAMerchant = (merchantId: string) =>
  EA_MERCHANT_ID === merchantId;
